module.exports = __webpack_public_path__ + "img/paw-print.09513290.png";